import { EContactDetailTypes, TFillPhoneAction } from '../index';

export const fillPhoneAction = (phone: string): TFillPhoneAction => ({
    type: EContactDetailTypes.FILL_PHONE,
    payload: {
        editedPhone: phone,
    },
});
